<div class="bg-workspace min-vh-100">
  <top-bar [title]="'News'"></top-bar>
  <div class="container py-4 px-md-5">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">News</li>
      </ol>
    </nav>

    <div class="row mb-4">
      <div class="col-auto mb-3 mb-sm-0">
        <h4 class="mb-0">Manager News</h4>
        <small class="text-muted">Create and maintain manager-facing news items.</small>
      </div>
      <div class="col-auto ms-auto">
        <button class="btn btn-primary rounded-pill px-4 py-2" type="button" (click)="createNews()">
          <app-icon name="plus" class="icon-white icon-sm me-1"></app-icon>
          Create news item
        </button>
      </div>
    </div>

    <div class="card">
      <div class="card-header row gy-3 gx-3 align-items-center">
        <div class="col-12 col-sm col-lg-6">
          <div class="position-relative w-100">
            <input
              name="search-term"
              type="text"
              class="form-control p-3"
              [(ngModel)]="searchTerm"
              (ngModelChange)="searchUpdated()"
              placeholder="Search by title, school or author"
            />
            <span class="btn position-absolute end-0 top-0 bottom-0 d-flex align-items-center" aria-hidden="true">
              <app-icon name="search" class="icon-primary"></app-icon>
            </span>
          </div>
        </div>
        <div class="col-12 col-sm-auto">
          <select
            name="type-filter"
            class="form-select p-3"
            [(ngModel)]="typeFilter"
            (ngModelChange)="typeFilterUpdated()"
          >
            <option [ngValue]="null">All types</option>
            <option *ngFor="let type of newsTypes" [ngValue]="type">{{ type | titlecase }}</option>
          </select>
        </div>
        <app-paginator
          class="col-auto ms-auto"
          [data]="newsPage"
          [pageable]="pageable"
          (newPage)="switchPage($event)"
        ></app-paginator>
      </div>

      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-sm">
            <thead>
              <tr class="table-row table-row-head text-nowrap">
                <th>Title</th>
                <th>Type</th>
                <th>Publication date</th>
                <th>Author</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="table-body" *ngIf="newsPage">
              <tr *ngFor="let item of items" class="table-row cursor-pointer" (click)="openNews(item)">
                <td>{{ item.content?.title }}</td>
                <td>
                  <span class="badge badge-outline-secondary fw-lighter text-uppercase">
                    {{ item.content?.type || 'NEWS' }}
                  </span>
                </td>
                <td>{{ (item.publicationDate) | date : 'd/MM/yyyy' }}</td>
                <td>{{ item.author?.details?.name }} {{ item.author?.details?.surname }}</td>
                <td class="text-end" (click)="$event.stopPropagation()">
                  <div class="dropleft">
                    <a class="dropdown-toggle-split btn btn-outline-secondary-2 rounded-circle py-2" id="dropdownMenuReference" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-reference="parent">
                      <app-icon name="more-vertical" class="icon-primary"></app-icon>
                    </a>
                    <div class="dropdown-menu py-2" aria-labelledby="dropdownMenuReference">
                      <a class="dropdown-item" (click)="openNews(item)">
                        <app-icon name="open" class="icon-white"></app-icon>
                        Open
                      </a>
                      <a class="dropdown-item" (click)="editNews(item)">
                        <app-icon name="edit" class="icon-white"></app-icon>
                        Edit
                      </a>
                      <a class="dropdown-item" (click)="requestDeleteNews(item)">
                        <app-icon name="delete" class="icon-white"></app-icon>
                        Delete
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="items.length === 0">
                <td colspan="5" class="text-center py-5 text-muted">No news items match the current search.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal #deleteConfirmModal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title fw-bold">Delete</h5>
      <button type="button" class="btn-close" (click)="deleteConfirmModal.hide()" aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <div>
        <strong>Are you sure you want to delete this news item?</strong>
      </div>
    </div>
    <div class="modal-footer text-end">
      <button type="button" class="btn btn-danger" (click)="deleteNews()" [disabled]="deleting">
        <span *ngIf="deleting" class="me-2 spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        Yes, delete
      </button>
      <button type="button" class="btn btn-primary" (click)="deleteConfirmModal.hide()" [disabled]="deleting">No</button>
    </div>
  </div>
</app-modal>
